import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import {API} from "../Contstant/constant";


export default function ProductView() {
  
  const [Product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  const [ActiveImage, setActiveImage] = useState(Product?.productimage?.[0]);

  const location = useLocation();
  let data = location.state.id || null;


  useEffect(() => {
    getProduct();
  }, []);

  useEffect(() => {

    if (Product && Product?.productimage && Product?.productimage?.length > 0) {

      setActiveImage(Product.productimage[0]?.url);
      // console.log(Product.productimage[0])
    }
  }, [Product]);

  const getProduct = async () => {
    try {
      const res = await axios.get(
        `${API}/api/product/getbyproductbyid/${data}`
      );
      setProduct(res.data);
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate()
  const handleViewImage = img => {
    // console.log(img,"Product.productimage[0]")
    setActiveImage(img?.url);
  };

  const handleNavigate = () => {
    navigate("/dashboard");
  };
  const [showDesc, setShowDesc] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowDesc(true), 100);
    return () => clearTimeout(t);
  }, []);


  if (loading) {
    return <div className="p-5">Loading product...</div>;
  }



  return (


    <div className="row m-auto mx-5">
      <div className="row mt-2 cl">
        <div className="col-md-2  me-auto">
          <IoArrowBackCircleSharp className="fs-2" onClick={handleNavigate} />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-6 m-auto">
          <div className="row">
            <div className="col-md-2">
              {Product?.productimage?.map(Ele => (
                <div key={Ele.id} className="col-md-2 p-1 thumbnail-container">

                  <img
                    loading="lazy"
                    className="thumbnail-image"
                    onMouseEnter={() => handleViewImage(Ele)}
                    width={100}
                    height={100}
                    src={Ele.url}
                    alt=""
                  />
                </div>
              ))}
            </div>

            <div className="main-image-container col-md-10 ">
              <div className="image-zoom-container">
                <img
                  loading="eager"
                  className="view-image"
                  src={ActiveImage}
                  alt=""
                  width="100%"

                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 ">
          <div className="product-details">
            <h2 className="product-name">{Product?.productName}</h2>

            <p className="product-category mt-3">
              <strong> Price : </strong>      <span className="real-price me-2 col-md-2">${Product?.realPrice}
              </span>  <span className="offer-price col-md-2">${Product?.offerPrice}</span>
            </p>

            <p className="product-subtitle"><strong>Short description</strong> : {Product?.subtitle}</p>
            <p className="product-category">
              <strong>Category:</strong> {Product?.category}
            </p>
            {Product?.manageStock && (
              <>
                <p className="product-unit">
                  <strong>Stock Status:</strong> {Product.stockStatus}
                </p>

                {Product.stockQuantity !== null && (
                  <p className="product-unit">
                    <strong>Available:</strong> {Product.stockQuantity} {Product.unit}
                  </p>
                )}
              </>
            )}

            <p className="product-packsize">
              <strong>Pack Size:</strong> {Product?.packsize} {Product?.unit}
            </p>
          </div>
        </div>
      </div>
      {showDesc && (
        <div dangerouslySetInnerHTML={{ __html: Product?.discription }} />
      )}

    </div>
  );
}
